module.exports = __webpack_public_path__ + "img/dangao.55a42691.gif";